module.exports = __webpack_public_path__ + "img/515aef60-d7f6-4143-8b0b-d1dd5c845873.aeaaddd0.png";